import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const { register } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('Пароль должен содержать минимум 6 символов');
      return;
    }

    setLoading(true);
    const result = await register(name, email, password);
    setLoading(false);

    if (result.requiresVerification) {
      setEmailSent(true);
    } else if (!result.success) {
      setError(result.message);
    }
  };

  if (emailSent) {
    return (
      <div className="auth-container">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '56px', marginBottom: '16px' }}>📧</div>
          <h2>Проверьте почту</h2>
          <p className="auth-subtitle" style={{ marginBottom: '1.5rem' }}>
            Мы отправили письмо с подтверждением на<br />
            <strong style={{ color: '#fff' }}>{email}</strong>
          </p>
          <p style={{ color: '#6060a0', fontSize: '14px', lineHeight: 1.6 }}>
            Нажмите на кнопку в письме — и аккаунт будет создан автоматически.
            Если письмо не пришло, проверьте папку «Спам».
          </p>
          <p className="auth-footer">
            Опечатались? <button
              onClick={() => setEmailSent(false)}
              style={{ background: 'none', border: 'none', color: '#4a90e2', cursor: 'pointer', fontSize: 'inherit', padding: 0, textDecoration: 'underline' }}
            >Назад</button>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Создать аккаунт</h2>
        <p className="auth-subtitle">Зарегистрируйтесь и получите 1 день бесплатно</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Имя</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="Ваше имя"
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
            />
          </div>

          <div className="form-group">
            <label>Пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Минимум 6 символов"
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Отправка письма...' : 'Зарегистрироваться'}
          </button>
        </form>

        <p className="auth-footer">
          Уже есть аккаунт? <Link to="/">Войти</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
